import _isEmail from 'validator/lib/isEmail';
import { ValidationResult } from './types';

export function isEmail(input: string): ValidationResult {
  return [_isEmail(input), 'Email is invalid'];
}
